import React from "react";
import { Layout, Typography, Row, Col, Card, Button, Space } from "antd";
import {
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import MainHeader from "../components/layout/MainHeader";
import MainFooter from "../components/layout/MainFooter";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

function ContactInfoCard({ icon, title, description, extra }) {
  return (
    <Card
      style={{
        borderRadius: 20,
        border: "1px solid #eadfce",
        boxShadow: "0 10px 28px rgba(0,0,0,0.04)",
        height: "100%",
      }}
      bodyStyle={{ padding: 24 }}
    >
      <div
        style={{
          width: 54,
          height: 54,
          borderRadius: 16,
          background: "linear-gradient(135deg, #d2ab71, #bb9259)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontSize: 24,
          marginBottom: 18,
          boxShadow: "0 10px 22px rgba(187,146,89,0.18)",
        }}
      >
        {icon}
      </div>

      <Title level={4} style={{ marginBottom: 10 }}>
        {title}
      </Title>

      <Paragraph style={{ color: "#666", lineHeight: 1.7, marginBottom: 8 }}>
        {description}
      </Paragraph>

      {extra && (
        <Paragraph
          style={{ marginBottom: 0, color: "#1f1f1f", fontWeight: 600 }}
        >
          {extra}
        </Paragraph>
      )}
    </Card>
  );
}

function Contato() {
  return (
    <Layout>
      <MainHeader />

      <Content>
        <section
          style={{
            background: "#111111",
            padding: "88px 24px",
          }}
        >
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <Row gutter={[40, 40]} align="middle">
              <Col xs={24} md={14}>
                <span
                  style={{
                    display: "inline-block",
                    padding: "8px 14px",
                    borderRadius: 999,
                    background: "rgba(210,171,113,0.12)",
                    border: "1px solid rgba(210,171,113,0.24)",
                    color: "#d2ab71",
                    fontSize: 13,
                    fontWeight: 700,
                    letterSpacing: 0.4,
                    marginBottom: 18,
                  }}
                >
                  FALE COM A GOLD SERVICE
                </span>

                <Title
                  style={{
                    color: "#fff",
                    fontSize: "clamp(34px, 5vw, 56px)",
                    lineHeight: 1.08,
                    marginBottom: 18,
                  }}
                >
                  Contato, atendimento e suporte
                </Title>

                <Paragraph
                  style={{
                    color: "rgba(255,255,255,0.75)",
                    fontSize: 18,
                    lineHeight: 1.75,
                    maxWidth: 700,
                    marginBottom: 28,
                  }}
                >
                  Nossa equipe está pronta para atender sua empresa, tirar
                  dúvidas sobre serviços, orçamento e informações de
                  funcionamento.
                </Paragraph>

                <Space wrap>
                  <Button
                    size="large"
                    icon={<WhatsAppOutlined />}
                    href="https://wa.me/5511996064416"
                    target="_blank"
                    style={{
                      height: 48,
                      borderRadius: 999,
                      padding: "0 22px",
                      background: "#25D366",
                      borderColor: "#25D366",
                      color: "#fff",
                      fontWeight: 700,
                    }}
                  >
                    Falar no WhatsApp
                  </Button>

                  <Button
                    size="large"
                    href="mailto:comercial@goldservicerm.com.br"
                    style={{
                      height: 48,
                      borderRadius: 999,
                      padding: "0 22px",
                      fontWeight: 600,
                    }}
                  >
                    Enviar e-mail
                  </Button>
                </Space>
              </Col>

              <Col xs={24} md={10}>
                <div
                  style={{
                    background: "#1b1b1b",
                    borderRadius: 24,
                    border: "1px solid rgba(255,255,255,0.08)",
                    padding: 28,
                    boxShadow: "0 18px 40px rgba(0,0,0,0.25)",
                  }}
                >
                  <Title level={4} style={{ color: "#fff", marginBottom: 18 }}>
                    Informações rápidas
                  </Title>

                  <Space direction="vertical" size={16} style={{ width: "100%" }}>
                    <div style={{ color: "#fff" }}>
                      <div
                        style={{
                          color: "#d2ab71",
                          fontWeight: 700,
                          marginBottom: 4,
                        }}
                      >
                        WhatsApp
                      </div>
                      <div>(11) 99606-4416</div>
                    </div>

                    <div style={{ color: "#fff" }}>
                      <div
                        style={{
                          color: "#d2ab71",
                          fontWeight: 700,
                          marginBottom: 4,
                        }}
                      >
                        E-mail
                      </div>
                      <div>comercial@goldservicerm.com.br</div>
                    </div>

                    <div style={{ color: "#fff" }}>
                      <div
                        style={{
                          color: "#d2ab71",
                          fontWeight: 700,
                          marginBottom: 4,
                        }}
                      >
                        Horário
                      </div>
                      <div>
                        Seg a Qui: 07h30 às 17h30
                        <br />
                        Sex: 07h30 às 16h30
                      </div>
                    </div>
                  </Space>
                </div>
              </Col>
            </Row>
          </div>
        </section>

        <section
          style={{
            padding: "88px 24px",
            background: "#f8f6f2",
          }}
        >
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <Row gutter={[24, 24]}>
              <Col xs={24} sm={12} lg={6}>
                <ContactInfoCard
                  icon={<PhoneOutlined />}
                  title="Atendimento"
                  description="Fale com nossa equipe para dúvidas e orçamento."
                  extra="(11) 9960-64416"
                />
              </Col>

              <Col xs={24} sm={12} lg={6}>
                <ContactInfoCard
                  icon={<MailOutlined />}
                  title="E-mails"
                  description="Entre em contato com nossos setores."
                  extra="comercial@goldservicerm.com.br"
                />
              </Col>

              <Col xs={24} sm={12} lg={6}>
                <ContactInfoCard
                  icon={<EnvironmentOutlined />}
                  title="Localização"
                  description="Atendimento em São Paulo."
                  extra="São Paulo - SP"
                />
              </Col>

              <Col xs={24} sm={12} lg={6}>
                <ContactInfoCard
                  icon={<ClockCircleOutlined />}
                  title="Funcionamento"
                  description="Horário de atendimento da empresa."
                  extra="Seg–Qui 07h30–17h30 | Sex 07h30–16h30"
                />
              </Col>
            </Row>
          </div>
        </section>

        <section
          style={{
            padding: "88px 24px",
            background: "#ffffff",
          }}
        >
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <Row gutter={[32, 32]}>
              <Col xs={24} lg={10}>
                <Title level={2} style={{ marginBottom: 18 }}>
                  Informações de contato
                </Title>

                <Space direction="vertical" size={24} style={{ width: "100%" }}>
                  <div>
                    <Title level={4} style={{ marginBottom: 8 }}>
                      Telefones
                    </Title>
                    <Paragraph style={{ marginBottom: 4, color: "#666" }}>
                      Canais de contato para comercial, atendimento e telefone
                      fixo.
                    </Paragraph>
                    <Paragraph style={{ marginBottom: 0, fontWeight: 600 }}>
                      (11) | 99606-4416 (Comercial)
                      <br />
                      (11) | 97584-9447 (Atendimento)
                      <br />
                      (11) | 99590-9929 (Financeiro)
                      <br />
                      (11) | 4555-4097 (Fixo)
                    </Paragraph>
                  </div>

                  <div>
                    <Title level={4} style={{ marginBottom: 8 }}>
                      E-mails
                    </Title>
                    <Paragraph style={{ marginBottom: 4, color: "#666" }}>
                      Entre em contato com o setor desejado.
                    </Paragraph>
                    <Paragraph style={{ marginBottom: 0, fontWeight: 600 }}>
                      comercial@goldservicerm.com.br
                      <br />
                      contato@goldservicerm.com.br
                      <br />
                      financeiro@goldservicerm.com.br
                    </Paragraph>
                  </div>

                  <div>
                    <Title level={4} style={{ marginBottom: 8 }}>
                      Endereço
                    </Title>
                    <Paragraph style={{ marginBottom: 0, color: "#666" }}>
                      São Paulo - SP
                    </Paragraph>
                  </div>

                  <div>
                    <Title level={4} style={{ marginBottom: 8 }}>
                      Horário de funcionamento
                    </Title>
                    <Paragraph style={{ marginBottom: 0, color: "#666" }}>
                      Segunda a quinta-feira
                      <br />
                      Das 07h30 às 17h30
                      <br />
                      Sexta-feira
                      <br />
                      Das 07h30 às 16h30
                    </Paragraph>
                  </div>
                </Space>
              </Col>

              <Col xs={24} lg={14}>
                <div
                  style={{
                    borderRadius: 24,
                    overflow: "hidden",
                    border: "1px solid #eadfce",
                    boxShadow: "0 12px 32px rgba(0,0,0,0.05)",
                    minHeight: 420,
                    background: "#f5f5f5",
                  }}
                >
                  <iframe
                    title="Mapa Gold Service"
                    src="https://www.google.com/maps?q=São%20Paulo&output=embed"
                    width="100%"
                    height="420"
                    style={{ border: 0, display: "block" }}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </section>

        <section
          style={{
            padding: "72px 24px 96px",
            background: "#111111",
          }}
        >
          <div style={{ maxWidth: 1100, margin: "0 auto", textAlign: "center" }}>
            <Title
              level={2}
              style={{
                color: "#fff",
                marginBottom: 16,
                fontSize: "clamp(30px, 4vw, 48px)",
              }}
            >
              Precisa falar com nossa equipe?
            </Title>

            <Paragraph
              style={{
                color: "rgba(255,255,255,0.75)",
                fontSize: 17,
                lineHeight: 1.75,
                maxWidth: 700,
                margin: "0 auto 28px",
              }}
            >
              Entre em contato para solicitar informações, tirar dúvidas ou
              receber atendimento especializado sobre nossos serviços.
            </Paragraph>

            <Space wrap>
              <Button
                size="large"
                icon={<WhatsAppOutlined />}
                href="https://wa.me/5511975849447"
                target="_blank"
                style={{
                  height: 50,
                  borderRadius: 999,
                  padding: "0 24px",
                  background: "#25D366",
                  borderColor: "#25D366",
                  color: "#fff",
                  fontWeight: 700,
                }}
              >
                Falar no WhatsApp
              </Button>

              <Button
                size="large"
                href="mailto:comercial@goldservicerm.com.br"
                style={{
                  height: 50,
                  borderRadius: 999,
                  padding: "0 24px",
                  fontWeight: 600,
                }}
              >
                Enviar e-mail
              </Button>
            </Space>
          </div>
        </section>
      </Content>

      <MainFooter />
    </Layout>
  );
}

export default Contato;